<template>
  <div>
    <van-actionsheet
      v-model="mainSheetVisible"
      :actions="actions"
      @select="onMainActionsheetSelect"
    />

    <van-actionsheet
      v-model="dayOfWeekSheetVisible"
      title="반영 요일 선택"
      style="text-align: center;"
      @cancel="onActionsheetCancel"
    >
      <DayOfWeekVisibilitySelect
        :course-dates="courseDates"
        @change="onChangeDayOfWeekVisible"
      />
    </van-actionsheet>

    <van-actionsheet
      v-model="titleSheetVisible"
      title="타이틀 수정 또는 로고 적용"
      :lock-scroll="false"
      @cancel="onActionsheetCancel"
    >
      <el-form
        ref="form"
        label-position="top"
        style="width: 100%;"
      >
        <el-form-item label="타이틀 수정">
          <el-input
            v-model="title"
          />
        </el-form-item>

        <el-form-item label="로고 이미지 적용">
          <el-upload
            class="logo-image-upload"
            action=""
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
            :on-change="handleFileUpload"
            :limit="1"
            :auto-upload="false"
            :file-list="fileList"
          >
            <el-button class="gray">
              로고 이미지 업로드
            </el-button>
          </el-upload>
        </el-form-item>
      </el-form>
    </van-actionsheet>

    <van-actionsheet
      v-model="visibleOptionSheetVisible"
      title="표시 항목 선택"
      @cancel="onActionsheetCancel"
    >
      <el-form
        ref="form"
        label-position="top"
        style="width: 100%;"
      >
        <el-form-item label="주간 기간 표시">
          <el-switch
            :value="showPeriod"
            @change="onChangeShowPeriod"/>
        </el-form-item>

        <el-form-item label="좌측 시간 표시">
          <el-switch
            :value="showFirstColumnTime"
            @change="onChangeShowFirstColumnTime"/>
        </el-form-item>

        <el-form-item label="수업 시간 표시">
          <el-switch
            :value="showCourseTime"
            @change="onChangeShowCourseTime"/>
        </el-form-item>

        <el-form-item label="수업 강사 표시">
          <el-switch
            :value="showInstructors"
            @change="onChangeShowInstructors"/>
        </el-form-item>
      </el-form>
    </van-actionsheet>

    <van-actionsheet
      v-model="invisibleCourseSheetVisible"
      title="미반영 수업 선택"
      @cancel="onActionsheetCancel"
    >
      <el-checkbox-group
        v-for="(parentCourseCategory, categoryIndex) in parentCourseCategories"
        :key="categoryIndex"
        v-model="invisibleParentCourses"
      >
        <el-checkbox
          v-for="(option, optionIndex) in parentCourseCategory.options"
          :key="optionIndex"
          :label="option.value"
          border
        >
          {{ option.label }}
        </el-checkbox>
      </el-checkbox-group>
    </van-actionsheet>

    <van-actionsheet
      v-model="fontSizeSheetVisible"
      title="글자 크기"
      @cancel="onActionsheetCancel"
    >
      <el-form
        label-position="top"
      >
        <el-form-item label="수업명 글자 크기">
          <div class="el-input-group__unit">
            <el-input-number
              :value="fontSize"
              @change="onChangeFontSize"
              controls-position="right"
              :min="50"
              :max="200"
              :step="10"
            />
            <div class="input-unit">
              %
            </div>
          </div>
        </el-form-item>
        <el-form-item label="강사/시간 글자 크기">
          <div class="el-input-group__unit">
            <el-input-number
              :value="subFontSize"
              @change="onChangeSubFontSize"
              controls-position="right"
              :min="50"
              :max="200"
              :step="10"
            />
            <div class="input-unit">
              %
            </div>
          </div>
        </el-form-item>
      </el-form>
    </van-actionsheet>

    <van-actionsheet
      v-model="breakTimeSheetVisible"
      title="브레이크 타임 설정"
      @cancel="onActionsheetCancel"
    >
      <BreakTimeEditor
        :value="breakTimes"
        @change="onChangeBreakTimes"
        :course-start-end-times="courseStartEndTimes"
      />
    </van-actionsheet>
  </div>
</template>

<script>
  import DayOfWeekVisibilitySelect from "./DayOfWeekVisibilitySelect";
  import BreakTimeEditor from "./BreakTimeEditor";
  import {computedGetters} from "../../utils/vuex-helper";

  export default {
    name: "TimeTableMobileOptionActionsheets",
    components: {
      BreakTimeEditor, DayOfWeekVisibilitySelect
    },
    props: {
      parentCourseCategories: {},
      courseDates: {},
      courseStartEndTimes: {}
    },
    data() {
      return {
        actions: [
          {
            name: "시간표 이미지 다운로드",
            sheetName: "downloadImage",
            disabled: false,
          },
          {
            name: "반영 요일 선택",
            sheetName: "dayOfWeekSheetVisible",
            disabled: false,
          },
          {
            name: "타이틀 수정 또는 로고 적용",
            sheetName: "titleSheetVisible",
            disabled: false,
          },
          {
            name: "표시 항목 선택",
            sheetName: "visibleOptionSheetVisible",
            disabled: false,
          },
          {
            name: "미반영 수업 선택",
            sheetName: "invisibleCourseSheetVisible",
            disabled: false,
          },
          {
            name: "글자 크기",
            sheetName: "fontSizeSheetVisible",
            disabled: false,
          },
          {
            name: "브레이크 타임 설정",
            sheetName: "breakTimeSheetVisible",
            disabled: false,
          },
        ],
        mainSheetVisible: false,
        dayOfWeekSheetVisible: false,
        titleSheetVisible: false,
        visibleOptionSheetVisible: false,
        invisibleCourseSheetVisible: false,
        fontSizeSheetVisible: false,
        breakTimeSheetVisible: false,
        fileList: [],
      }
    },
    computed: {
      ...computedGetters([
        "centerAccount"
      ]),
      ...computedGetters([
        "dayOfWeekVisible",
        "backgroundColor",
        "showPeriod",
        "showFirstColumnTime",
        "showCourseTime",
        "showInstructors",
        "fontSize",
        "subFontSize",
        "breakTimes",
      ], "timeTable"),
      title: {
        get () {
          return this.$store.getters['timeTable/getTitle']
        },
        set (value) {
          this.$store.commit('timeTable/setTitle', value)
        }
      },
      invisibleParentCourses: {
        get () {
          return this.$store.getters['timeTable/getInvisibleParentCourses']
        },
        set (value) {
          this.$store.commit('timeTable/setInvisibleParentCourses', value)
        }
      }
    },
    watch: {
      courseDates(course) {
        const isCourseEmpty = course.length === 0;

        this.actions[0].disabled = isCourseEmpty;
        this.actions[1].disabled = isCourseEmpty;  
      }
    },
    methods: {
      openActionsheets() {
        this.mainSheetVisible = true
      },
      onMainActionsheetSelect(item) {
        this.mainSheetVisible = false;

        if (item.sheetName === "downloadImage") {
          return this.$emit('requestDownloadImage')
        }

        this[item.sheetName] = true;
      },
      onActionsheetCancel() {
        this.mainSheetVisible = true;
      },
      onChangeDayOfWeekVisible(value) {
        this.$store.commit("timeTable/setDayOfWeekVisible", value)
      },
      onChangeBackgroundColor(value) {
        this.$store.commit("timeTable/setBackgroundColor", value)
      },
      onChangeShowPeriod(value) {
        this.$store.commit("timeTable/setShowPeriod", value)
      },
      onChangeShowFirstColumnTime(value) {
        this.$store.commit("timeTable/setShowFirstColumnTime", value)
      },
      onChangeShowCourseTime(value) {
        this.$store.commit("timeTable/setShowCourseTime", value)
      },
      onChangeShowInstructors(value) {
        this.$store.commit("timeTable/setShowInstructors", value)
      },
      onChangeInvisibleParentCourses(value) {
        this.$store.commit("timeTable/setInvisibleParentCourses", value)
      },
      onChangeFontSize(value) {
        this.$store.commit("timeTable/setFontSize", value)
      },
      onChangeSubFontSize(value) {
        this.$store.commit("timeTable/setSubFontSize", value)
      },
      onChangeBreakTimes(value) {
        this.$store.commit("timeTable/setBreakTimes", value)
      },
      handleRemove(file, fileList) {
        this.fileList = [];
        this.$emit('onUpdateLogoImage', null)
      },
      handleExceed(files, fileList) {
        this.$message.warning(`하나의 이미지만 올릴 수 있습니다.`);
      },
      handleFileUpload(file, fileList) {
        let reader = new FileReader();
        reader.onload = e => {
          this.$emit('onUpdateLogoImage', e.target.result)
        };

        reader.readAsDataURL(file.raw);
      },
    }
  }
</script>

<style scoped>

</style>